import { Avatar, Button, Dropdown, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { CrossIcon, TickIcon } from "../../../../../atoms/CustomIcons";
import { CaretDownOutlined } from "@ant-design/icons";
import { useRef } from "react";
import { GetDealType, ProposalDetailType } from "../../../ducks/types";
import { changeProposalStatus, sentProposalDoc } from "../../../ducks/services";
import { useAppDispatch } from "../../../../../config/hooks";
import { getPotentialDealDetails } from "../../../ducks/actions";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";

interface HeaderProps {
  companyId: string;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  estimateId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  dealsDetailData: GetDealType | null;
  addProposal?: boolean;
  proposalDetailData: ProposalDetailType | null;
  handleSubmitEstimate: () => void;
  proposalId?: string;
  dealId?: string;
}

export default function DocumentHeader({
  companyId,
  btnText1,
  btnIcon1,
  setLoading,
  dealsDetailData,
  addProposal,
  proposalDetailData,
  estimateId,
  handleSubmitEstimate,
}: HeaderProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const dealId = pathSegments[pathSegments.length - 3];

  const changeStatus = (val: string) => {
    setLoading(true);
    functionChangeStatus(val);
  };

  const functionChangeStatus = (val: string) => {
    const payload = {
      status: val,
    };
    console.log("payload", payload);
  };

  const handleStatusChange = (status: string) => {
    setLoading(true);
    if (dealsDetailData?.id) {
      const payload = {
        status,
        deal_id: dealsDetailData.id,
      };
      changeProposalStatus(payload, dealId)
        .then(() => {
          setLoading(false);
          dispatch(getPotentialDealDetails(dealsDetailData.id));
          SuccessMessage("Status changed");
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  const statusItems = [
    {
      key: "inactive",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("inactive");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />{" "}
          Inactive{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "onboarding",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("onboarding");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#2098EE", borderRadius: "2px" }}
          />{" "}
          Onboarding{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "active",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("active");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />{" "}
          Active{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "suspended",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("suspended");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#F06400", borderRadius: "2px" }}
          />{" "}
          Suspended{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "archived",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("archived");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#98A3A9", borderRadius: "2px" }}
          />{" "}
          Archived{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  const sentProposalDocFunc = (id: string) => {
    setLoading(true);
    const payload = {
      proposal_id: id ?? "",
      companyId: companyId,
    };
    sentProposalDoc(payload)
      .then(() => {
        setLoading(false);
        if (dealsDetailData?.id) {
          const payload = {
            status: "sent",
            deal_id: dealsDetailData.id,
          };
          changeProposalStatus(payload, dealId)
            .then(() => {
              setLoading(false);
              dispatch(getPotentialDealDetails(dealsDetailData.id));
              SuccessMessage("Proposal sent");
              navigate(`/deals-detail/${estimateId}/${companyId}`);
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <div className="estimateHeader">
      <div className="headerLeft">
        <Button
          size="large"
          type="link"
          className="p-0 m-20 close_popup"
          onClick={() => navigate(`/deals-detail/${estimateId}/${companyId}`)}
          icon={<CrossIcon style={{ color: "#151718" }} />}
        />
        <div className="estimateHeaderText">
          <div className="estimateTitle">
            <div className="estimateTitleText">
              {dealsDetailData?.name ?? ""} : <b>Proposal doc</b>
            </div>
            {!addProposal && (
              <Dropdown
                menu={{
                  items: statusItems,
                  selectable: true,
                }}
                trigger={["click"]}
                overlayClassName="status_dropdown_overlay"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  className={`status_dropdown in_progress_status`}
                  ref={dropdownRef}
                >
                  {proposalDetailData?.status === "in_progress"
                    ? "In progress"
                    : proposalDetailData?.status === "approval_pending"
                    ? "Approval pending"
                    : proposalDetailData?.status}
                  <div className="icon_arrow">
                    <CaretDownOutlined />
                  </div>
                </Button>
              </Dropdown>
            )}
          </div>
          <div className="description">
            <Image src="/images/estimate/home-icon.svg" preview={false} />
            {dealsDetailData?.property?.name ?? ""}
          </div>
        </div>
      </div>
      <div className="two_btns">
        {btnText1 && (
          <Button htmlType="submit" size="large" className="btn-sm">
            {btnIcon1 && btnIcon1} {btnText1}
          </Button>
        )}
        <Button onClick={handleSubmitEstimate} className="white-btn">
          Save
        </Button>

        {dealsDetailData?.status === "in_progress" && (
          <Button
            htmlType="submit"
            size="large"
            className="mint-btn"
            onClick={() => handleStatusChange("approval_pending")}
          >
            Send for approval
          </Button>
        )}
        {dealsDetailData?.status === "approval_pending" && (
          <Button
            htmlType="submit"
            size="large"
            className="violet-btn"
            onClick={() => handleStatusChange("ready")}
          >
            Approve
          </Button>
        )}
        {dealsDetailData?.status === "ready" && (
          <Button
            htmlType="submit"
            size="large"
            className="light-blue-btn"
            onClick={() => sentProposalDocFunc(dealId)}
          >
            Sent to customer
          </Button>
        )}
        {/* {dealsDetailData?.status === "sent" && (
          <Button htmlType="submit" size="large" className="light-blue-btn">
            Follow up
          </Button>
        )} */}
      </div>
    </div>
  );
}
